import Flex from '~/common/components/Flex';
import QuestionLibraryErrorMessage from '~/common/components/QuestionLibrary/components/utilityComponents/QuestionLibraryErrorMessage';

import type { QuestionLibraryError } from '../../../utils/errorHandling';

type FieldArrayInputContainerProps = {
  error?: QuestionLibraryError;
  children?: React.ReactNode;
};

export default function FieldArrayInputContainer({
  error,
  children,
}: Readonly<FieldArrayInputContainerProps>) {
  return (
    <Flex direction={'column'} justifyContent={'flex-start'}>
      {children}
      {error && <QuestionLibraryErrorMessage error={error} />}
    </Flex>
  );
}
